module.exports = __webpack_public_path__ + "img/article-gb-other-2.2d2d9d6c.png";